.separator {
  margin: 0;
  border-bottom: 0;
}

.edit-menu {
  padding: 5px 20px;
}
